import React, { useCallback } from 'react'
import { Main, MainBody, MainTop, MainTopTitle, WhiteBox } from '@/components/Layout'
import Resx from '@/components/Resx'
import { Button } from '@/components/button'
import { Col, FormGroup, Label, Row } from 'reactstrap'
import context from '@/context'
import { useBackgroundJobTracking } from '@/hooks/useBackgroundJobRunning'
import { Input } from '@/components/inputs'

export const TemporaryJobRunner = React.memo(function TemporaryJobRunner (props) {
  const [ids, setIds] = React.useState('')
  const { running: submissionGroupGenerationRunning, start: onSubmissionGroupGenerationClick } = useBackgroundJobTracking(
    context.api.temporaryJobService.triggerSubmissionGroupGeneration
  )
  const { running: reportAttachmentsGenerationRunning, start: OnReportAttachmentGenerationClick } = useBackgroundJobTracking(
    context.api.temporaryJobService.triggerReportAttachmentGeneration
  )
  const { running: orphanFinesCleanUpRunning, start: onOrphanFilesCleanUpClick } = useBackgroundJobTracking(
    context.api.temporaryJobService.triggerOrphanFilesCleanUp
  )
  const { running: extendedGraceDueDateCheckRunning, start: onExtendedGraceDueDateCheckClick } = useBackgroundJobTracking(
    context.api.temporaryJobService.triggerExtendedGraceDueDateCheck
  )
  const { running: triggerInstitutionReportGroupGenerationRunning, start: onTriggerInstitutionReportGroupGeneration } = useBackgroundJobTracking(
    context.api.temporaryJobService.triggerInstitutionReportGroupGeneration
  )
  const {
    running: triggerInstitutionExportGeneration,
    start: onTriggerInstitutionExportGeneration
  } = useBackgroundJobTracking(
    context.api.temporaryJobService.triggerInstitutionExportGeneration
  )

  const triggerReportSubmissionGroupAcceptance = useCallback(
    () => context.api.temporaryJobService.triggerReportSubmissionGroupsAcceptance(ids),
    [ids]
  )

  const {
    running: triggerReportSubmissionGroupsAcceptanceRunning,
    start: onTriggerReportSubmissionGroupsAcceptance
  } = useBackgroundJobTracking(
    triggerReportSubmissionGroupAcceptance
  )

  return (<Main>
    <MainTop>
      <MainTopTitle>
        Workflow runner
      </MainTopTitle>
    </MainTop>
    <MainBody>
      <WhiteBox>
        <Row>
          <Col>
            <FormGroup>
              <Label><Resx name='DataCrossings.Jobs' /></Label>
              <div>
                <Button onClick={onTriggerInstitutionReportGroupGeneration}
                  disabled={triggerInstitutionReportGroupGenerationRunning}>
                  Trigger institution report group generation
                </Button>
                &nbsp;
                <Button onClick={onTriggerInstitutionExportGeneration}
                  disabled={triggerInstitutionExportGeneration}>
                  Trigger institution export generation
                </Button>
                &nbsp;
                <Button onClick={onSubmissionGroupGenerationClick} disabled={submissionGroupGenerationRunning}>
                  Trigger submission group generation
                </Button>
                &nbsp;
                <Button onClick={onExtendedGraceDueDateCheckClick} disabled={extendedGraceDueDateCheckRunning}>
                  Trigger extended grace due date check
                </Button>
                &nbsp;
                <Button onClick={onOrphanFilesCleanUpClick} disabled={orphanFinesCleanUpRunning}>
                  Trigger orphan files clean up
                </Button>
                &nbsp;
                <Button onClick={OnReportAttachmentGenerationClick} disabled={reportAttachmentsGenerationRunning}>
                  Trigger regeneration of export files
                </Button>
              </div>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Row>
                <Label>Report group Acceptance</Label>
              </Row>
              <Row>
                <Label>Enter comma separated report submission group ids</Label>
              </Row>
              <Row>
                <Input value={ids} onChange={(e) => setIds(e.target.value)} />
              </Row>
              <Row>
                <Button onClick={onTriggerReportSubmissionGroupsAcceptance} disabled={triggerReportSubmissionGroupsAcceptanceRunning}>
                  Trigger report submission groups acceptance
                </Button>
              </Row>
            </FormGroup>
          </Col>
        </Row>
      </WhiteBox>
    </MainBody>
  </Main>)
})



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/temploraryJobRunner.js